import BaseApiService from './api.base.service'

class ReservedAreaApiService extends BaseApiService {
  constructor() {
    super('reserved-area')
  }

  getActiveBannerList() {
    return this.callGet('/active-banners')
  }

  getMagazinesByEndpoint(endpoint) {
    return this.callGet(`/magazines/info?link=${endpoint}`)
  }

  logAccessFromLiveBox(contentId) {
    return this.callPost(
      `/live-box/access/log`,
      { Id: contentId },
      {
        headers: { 'Content-Type': 'application/json' },
      }
    )
  }
}

export const reservedAreaApi = new ReservedAreaApiService()
